import { Virtualizer } from "@tanstack/react-virtual"
import { displayedPhotosAtom, currentPhotoAtom } from "@/store/photo/photos-state"
import { usePrevious } from "@/utils/usePrevious"
import { useEffect } from "react"
import { useAtom } from "jotai"
import { PhotoRecord } from "@/lib/catalog/types"

export const useCenterNewlyMarkedReferences = (props: {
	columnVirtualizer: Virtualizer<HTMLDivElement, Element>
	isShown: boolean
}) => {
	const { isShown, columnVirtualizer } = props
	const [displayedPhotos] = useAtom(displayedPhotosAtom)
	const [currentPhoto] = useAtom(currentPhotoAtom)
	const previousPhoto = usePrevious<PhotoRecord | null>(currentPhoto)

	useEffect(() => {
		if (
			isShown &&
			previousPhoto &&
			currentPhoto &&
			previousPhoto.id === currentPhoto.id &&
			currentPhoto.kind === "reference" &&
			previousPhoto.kind !== "reference"
		) {
			const index = displayedPhotos.findIndex((p) => p.id === currentPhoto?.id)
			if (index === -1) return

			const offset = columnVirtualizer.getOffsetForIndex(index, "center")

			if (offset) {
				const x =
					offset[0] === 0 ? 0 : offset[0] + columnVirtualizer.options.estimateSize(0) / 2
				columnVirtualizer.scrollToOffset(x, { behavior: "smooth" })
			}
		}
	}, [isShown, previousPhoto, columnVirtualizer, currentPhoto])
}
